import { jsx as _jsx } from "react/jsx-runtime";
import { Box, coreTheme } from '@kolmeo/ui-core';
const ListItemSeperator = (props) => {
    const { palette } = coreTheme;
    return (_jsx(Box, { height: 1, backgroundColor: palette.borderLight, ...props }));
};
export default ListItemSeperator;
